/**
 * Created by lihanying on 2017/7/6.
 */
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import * as actions from './action'
import Info from './component/info'
import { Spin } from 'antd'

class ClubInfo extends React.Component {
  static defaultProps = {
    clubInfos: {},
    bankInfo: {},
  }
  state = {
    loading: true,
  }

  componentDidMount() {
    this.props.fetchClubInfo()
    this.props.fetchBankInfo() //银行卡信息
    this.props.getUnionPayRelatedInfo().then((res) => {
      this.setState({ loading: false })
    }) // 银联钱包信息
  }

  render() {
    const { clubInfos, bankInfo } = this.props
    return (
      <div>
        {this.state.loading ? (
          <Spin
            tip="正在加载..."
            className="level-loading"
            style={{ textAlign: 'center' }}
          />
        ) : (
          <Info
            clubInfo={clubInfos.info}
            message={clubInfos.message}
            bankInfo={bankInfo}
            fetchEditClubInfo={this.props.fetchEditClubInfo}
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    clubInfos: state.getClubInfo.clubInfos,
    bankInfo: state.getClubInfo.bankInfo,
    unionPayInfo: state.getClubInfo.unionPayInfo,
  }
}
export default withRouter(connect(mapStateToProps, actions)(ClubInfo))



// WEBPACK FOOTER //
// ./src/containers/ClubInfo/index.js